import { InjectionToken } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const LANGUAGE_SWITCHER_FLAG_MAP: InjectionToken<Record<string, string>> = new InjectionToken<
  Record<string, string>
>('LanguageSwitcherFlagMap');
